import React, { useState } from 'react';
import { Typography, Stack, Modal, Box, IconButton, Snackbar, Alert } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import close2 from '../../../icons/close2.svg';

export interface RegistrationInviteModalProps {
  open: boolean;
  onClose: () => void;
  link: string;
}

const SuccessModal = (props: RegistrationInviteModalProps) => {
    const [snackBarOpen, setSnackBarOpen] = useState(false);

    return (
        <div>
            <Modal
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropProps={{
                    invisible: false
                }}>
                <Box sx={{
                    position: 'absolute' as 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 520,
                    height: 579,
                    background: '#FFFFFF',
                    boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                    borderRadius: '24px',
                    p: 4,
                    outline: 'none'
                }}>
                    <Stack direction="column"
                        justifyContent="start"
                        alignItems="space-between"
                        spacing={1}>
                        <Stack 
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            sx={{ position: 'relative' }}
                        >
                            <Typography sx={{
                                fontFamily: '"Work Sans",Sans serif',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                fontSize: '18px',
                                lineHeight: '22px',
                                color: '#14142B',
                                marginLeft: "0 !important"
                            }}>Payment Request Link</Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="Close modal"
                                onClick={props.onClose}
                                sx={{
                                    position: 'absolute',
                                    right: 0,
                                }}
                            >
                                <img src={close2} alt="close" />
                            </IconButton>
                        </Stack>
                        <Stack
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                            sx={{ 
                                minHeight: 470,
                            }}
                        >
                            <React.Fragment>
                                <Typography sx={{
                                    fontFamily: "Work Sans",
                                    fontStyle: 'normal',
                                    fontWeight: 600,
                                    fontSize: '24px',
                                    lineHeight: '25px',
                                    color: '#14142B',
                                    textAlign: 'center',
                                    marginTop: '25px !important'
                                }}>
                                    Payment Request has been sent.
                                </Typography>
                                <Typography sx={{
                                    fontFamily: "Work Sans",
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '18px',
                                    lineHeight: '25px',
                                    color: '#14142B',
                                    textAlign: 'center',
                                    marginTop: '28px !important'
                                }}>
                                    It may take a few minutes before the recipient receives it.
                                    <br/><br/>
                                    You can also send this link to them from your own email.
                                </Typography>
                                <Box sx={{
                                    background: '#F1F0F5',
                                    borderRadius: '24px',
                                    width: 318,
                                    padding: '18px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative',
                                    marginTop: '25px !important',
                                }}>
                                    <Typography 
                                        sx={{
                                            fontFamily: "Work Sans",
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            fontSize: '18px',
                                            lineHeight: '22px',
                                            color: '#14142B',
                                            marginRight: '25px',
                                        }}
                                    >
                                        {`Click to copy link`}
                                    </Typography>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="copy link"
                                        onClick={() => {
                                            navigator.clipboard.writeText(props.link);
                                            setSnackBarOpen(true);
                                        }}
                                        sx={{
                                            position: 'absolute',
                                            right: 5,
                                        }}
                                        id="copy-activation-link"
                                    >
                                        <ContentCopyIcon sx={{ width: '22px', height: '22px', fill: '#14142B' }} />
                                    </IconButton>
                                </Box>
                                <Typography sx={{
                                    fontFamily: "Work Sans",
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '18px',
                                    lineHeight: '25px',
                                    color: '#14142B',
                                    textAlign: 'center',
                                    marginTop: '15px !important'
                                }}>
                                    Note: This link is specific for this one payment request
                                </Typography>
                            </React.Fragment>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
            <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={snackBarOpen} autoHideDuration={4000} onClose={() => {setSnackBarOpen(false)}}>
                <Alert onClose={() => {setSnackBarOpen(false)}} severity="success" sx={{ width: '100%' }} id="message-copied">
                    Copied to Clipboard
                </Alert>
            </Snackbar>
        </div>
    )
}
export default SuccessModal;